import { setContext } from '@apollo/client/link/context'
import i18n from 'i18next'

import { COMMUNO_CONTEXT_IRI_HEADER } from '@/auth/contextRequestHeader'
import { ensureOidcUserFreshForApi } from '@/auth/ensureOidcUserFreshForApi'

export const ApolloRefreshTokenAuthMiddleware = setContext(
  async (operation, { headers }) => {
    const user = await ensureOidcUserFreshForApi({
      source: 'apollo',
      operationName: operation.operationName ?? null,
    })

    const token = user?.access_token

    const storedContextIri =
      typeof window !== 'undefined' ? localStorage.getItem('contextIri') : null
    const existingContextIriHeader =
      headers?.[COMMUNO_CONTEXT_IRI_HEADER] ??
      headers?.[COMMUNO_CONTEXT_IRI_HEADER.toLowerCase()]
    const contextIriToUse = existingContextIriHeader ?? storedContextIri

    if (token) {
      return {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
          'accept-language': i18n.language,
          ...(contextIriToUse
            ? { [COMMUNO_CONTEXT_IRI_HEADER]: contextIriToUse }
            : {}),
        },
      }
    }

    return {
      headers: {
        ...headers,
        'accept-language': i18n.language,
      },
    }
  }
)
